import { Link } from "gatsby";
import React from "react";
import styled from "styled-components";

export const NavLink = ({
  children,
  isCareers,
  activeStyle,
  to,
  tabIndex,
}: {
  children?: React.ReactNode;
  isCareers?: boolean;
  activeStyle: React.CSSProperties;
  to: string;
  tabIndex?: number;
}): JSX.Element => {
  const position = isCareers ? "relative" : "static";

  return (
    <NavLinkStyled
      style={{ position: position }}
      // activeStyle={activeStyle}
      to={to}
      tabIndex={tabIndex || 0}
      getProps={({ isPartiallyCurrent }) =>
        isPartiallyCurrent
          ? {
              style: {
                ...activeStyle,
              },
            }
          : {}
      }
    >
      {children}
    </NavLinkStyled>
  );
};
const NavLinkStyled = styled(Link)`
  color: ${(props) => props.theme.colours.foreground};
  text-decoration: none;
  font-size: 1rem;
  font-weight: bold;
  line-height: 100%;
  margin-right: 1.5rem;
  transition: all 0.2s ease-in;
  &:active {
    outline: none;
  }
  &:hover {
    cursor: pointer;
    color: ${(props) => props.theme.colours.orange};
  }
  @media (max-width: ${(props) => props.theme.screenSize.m}px) {
    margin: 0 0 10px 1rem;
  }
`;

export default NavLink;
